/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupTakeawayIcon24Solid = forwardRef('FoodDrinkCupTakeawayIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.545 2a2.625 2.625 0 0 0-2.527 1.914L5.713 5H11.5a.5.5 0 0 1 0 1H4.75a1.25 1.25 0 1 0 0 2.5h14.5a1.25 1.25 0 1 0 0-2.5h-.682l-.586-2.086A2.625 2.625 0 0 0 15.455 2h-6.91Z" }),
        React.createElement("path", { d: "M6.193 20.27 5.267 10h13.466l-.926 10.27A3 3 0 0 1 14.819 23H9.18a3 3 0 0 1-2.988-2.73Z" })));
});
